import React from 'react';
import PropTypes from 'prop-types';
import './icon.scss';
import clsx from 'clsx';
import { IconColors, IconSizes } from './icon-dictionary';
import Library, { DefaultIcon, IconTypes } from './icon-library';

const Icon = React.forwardRef(({
  type, size, color, className, strokeWidth, tabIndex, onClick,
}, ref) => {
  const classNames = clsx('icon-cont', color, type.toLowerCase(), size, className);
  const LibIcon = Library[type] || DefaultIcon;

  const handleOnClick = () => {
    if (onClick && typeof onClick === 'function') {
      onClick.call(null);
    }
  };

  return (
    <LibIcon
      onClick={handleOnClick}
      ref={ref}
      className={classNames}
      strokeWidth={strokeWidth}
      tabIndex={tabIndex}
    />
  );
});

Icon.propTypes = {
  type: PropTypes.oneOf(Object.values(IconTypes)),
  size: PropTypes.string,
  color: PropTypes.string,
  strokeWidth: PropTypes.number,
  className: PropTypes.string,
  tabIndex: PropTypes.number,
  onClick: PropTypes.func,
};

Icon.defaultProps = {
  type: '',
  size: IconSizes.LARGE,
  color: IconColors.DARK,
  strokeWidth: 2,
  className: '',
  tabIndex: -1,
  onClick: null,
};

export {
  Icon as default,
  IconTypes,
  IconColors,
  IconSizes,
};
